import Backbone from 'backbone';
import $ from 'jquery';

import ifCreateFromHash from 'util/ifCreateFromHash';
import runModal from 'ui-library/runModal';
import {CreateAssemblyModal} from 'assembly/CreateAssemblyModal';

class CreateAssemblyLink extends Backbone.View {
  render() {
    $(document).on('click', '.js-create-new-assembly', (e) => {
      e.preventDefault();
      runModal(CreateAssemblyModal, {});
    });

    ifCreateFromHash('#create/assembly', () => {
      runModal(CreateAssemblyModal, {});
    });
    return this;
  }
}

export default CreateAssemblyLink;
